import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  MessstellenListeSummary,
  kennzeichnungLabel
} from '../../../../../Models/messstelle.model';
import { InbetriebnahmeService } from '../../../../../Services/inbetriebnahme.service';
import {
  IbnProtokollAuswahl,
  IbnProtokollDialogData,
  MessstelleAuswahlOption,
  auswahlAnzeigeName,
  messstellenAuswahlOptionen
} from '../ibn-protokoll-auswahl.model';

/**
 * Variante 1: eine einzelne Messstelle als vollständiges PDF.
 *
 * Fachlich unverändert gegenüber dem früheren Sammeldialog – Inbetriebnahme
 * wählen, Messstelle mit Prüfstatus, Kennzeichnung und Langtext wählen,
 * PDF erstellen. Die Messstellen einer Inbetriebnahme werden erst geladen,
 * wenn sie wirklich gebraucht werden.
 */
@Component({
  selector: 'app-ibn-protokoll-messstelle-dialog',
  templateUrl: './ibn-protokoll-messstelle-dialog.component.html',
  styleUrls: ['./ibn-protokoll-messstelle-dialog.component.css']
})
export class IbnProtokollMessstelleDialogComponent implements OnInit {
  inbetriebnahmen: MessstellenListeSummary[] = [];
  inbetriebnahmeId: number | null = null;

  messstellen: MessstelleAuswahlOption[] = [];
  messstelleId: number | null = null;

  /** Beschriftung der Kennzeichnungsspalte dieser Liste – „KKS“, „AKZ“, … */
  kennzeichnungTitel = 'Kennzeichnung';

  ladeMessstellen = false;
  ladeFehler = '';

  constructor(
    public dialogRef: MatDialogRef<IbnProtokollMessstelleDialogComponent, IbnProtokollAuswahl | null>,
    @Inject(MAT_DIALOG_DATA) public data: IbnProtokollDialogData,
    private service: InbetriebnahmeService
  ) { }

  ngOnInit(): void {
    this.inbetriebnahmen = this.data.projekt?.inbetriebnahmen ?? [];

    // Bei genau einer Inbetriebnahme ist die Auswahl ohnehin eindeutig.
    if (this.inbetriebnahmen.length === 1) {
      this.inbetriebnahmeId = this.inbetriebnahmen[0].id;
      this.ladeMessstellenListe(this.inbetriebnahmeId);
    }
  }

  onInbetriebnahmeChange(id: number): void {
    this.inbetriebnahmeId = id;
    this.messstelleId = null;
    this.messstellen = [];

    this.ladeMessstellenListe(id);
  }

  private ladeMessstellenListe(listeId: number): void {
    this.ladeMessstellen = true;
    this.ladeFehler = '';

    this.service.getListe(listeId).subscribe({
      next: liste => {
        this.messstellen = messstellenAuswahlOptionen(liste);
        this.kennzeichnungTitel = kennzeichnungLabel(liste.kennzeichnungsArt);

        // Bei genau einer Messstelle die Auswahl gleich setzen.
        if (this.messstellen.length === 1) {
          this.messstelleId = this.messstellen[0].id;
        }

        this.ladeMessstellen = false;
      },
      error: () => {
        this.messstellen = [];
        this.ladeMessstellen = false;
        this.ladeFehler = 'Die Messstellen dieser Inbetriebnahme konnten nicht geladen werden.';
      }
    });
  }

  get istGueltig(): boolean {
    return this.inbetriebnahmeId != null && this.messstelleId != null;
  }

  get ausgewaehlteMessstelle(): MessstelleAuswahlOption | null {
    return this.messstellen.find(m => m.id === this.messstelleId) ?? null;
  }

  abbrechen(): void {
    this.dialogRef.close(null);
  }

  exportieren(): void {
    if (!this.istGueltig) {
      return;
    }

    const messstelle = this.ausgewaehlteMessstelle;

    this.dialogRef.close({
      umfang: 'messstelle',
      variante: 'einzeln',
      projektId: this.data.projekt.id,
      inbetriebnahmeId: this.inbetriebnahmeId ?? undefined,
      messstelleId: this.messstelleId ?? undefined,
      bezeichnung: messstelle ? auswahlAnzeigeName(messstelle) : 'Messstelle'
    });
  }
}
